// A2F-764: Section 4 body — regulatory packs (v2 simple).
//
// Same 5 rows as v1 PacksList.
//
// IND Section Headings: locked-on (built-in feature).
// Cover letter validation: real, togglable, ships ind_v0 rules.
// FDA Writing Standards: real, togglable as of A2F-796 (was
//   previously "Coming soon" while fda_writing_standards_v0 didn't
//   exist in packs.ts).
// eCTD formatting: real, togglable as of A2F-801. Ships 7 rules
//   from ectd_formatting_v0; six additional formatting rules
//   (margins, shading, hyperlinks, headers/footers, black-body text)
//   are deferred to A2F-808 pending real Pro user demand.
// NDA Reviewers Guide: real, togglable as of A2F-803. Ships 1 rule
//   (no pasted backbone TOC) from nda_reviewers_guide_v0; four
//   additional document-level rules (outline format, hyperlink
//   count, PED table, not-mostly-narrative) deferred until their
//   heuristics are firmer.

import { PackRow } from '../onboard/v2/PackRow'
import type { PacksState } from '../onboard/v2/PacksList'

interface SectionPacksProps {
  packs: PacksState
  onTogglePack: (key: keyof PacksState) => void
}

export function SectionPacks({ packs, onTogglePack }: SectionPacksProps) {
  return (
    <div>
      <PackRow
        iconLetter="H"
        name="IND Section Headings"
        description="Browse and insert CTD section headings from the taskpane."
        tier="FREE"
        on={packs.indSectionHeadings}
        disabled
      />
      <PackRow
        iconLetter="C"
        name="Cover letter validation"
        description="5 required elements per FDA Technical Conformance Guide."
        tier="PRO"
        on={packs.coverLetterValidation}
        onToggle={() => onTogglePack('coverLetterValidation')}
      />
      <PackRow
        iconLetter="T"
        name="FDA Writing Standards"
        description='FDA-preferred terms, ICH M4 alignment, regulatory grammar ("data are", "criteria are"). 4 rules.'
        tier="PRO"
        on={packs.fdaTerminology}
        onToggle={() => onTogglePack('fdaTerminology')}
      />
      <PackRow
        iconLetter="F"
        name="eCTD formatting conventions"
        description="Body font (Times New Roman 9-12pt), image alt text and size, no strikethrough or hidden text. 7 rules."
        tier="PRO"
        on={packs.ectdFormatting}
        onToggle={() => onTogglePack('ectdFormatting')}
      />
      {/* A2F-850 followup: NDA Reviewers Guide pack temporarily hidden
          from users. The pack itself is filtered out of ALL_PACKS via
          HIDDEN_PACK_IDS in packs.ts, but this configurator surface is
          a hand-listed PackRow set (not driven from the registry) so
          the row also needs to disappear here to actually hide. To
          restore: uncomment this PackRow and remove the id from
          HIDDEN_PACK_IDS in packs.ts.
      <PackRow
        iconLetter="R"
        name="NDA Reviewers Guide"
        description="Document-level checks for an FDA NDA Reviewer's Guide — flag a pasted-as-text backbone TOC. 1 rule."
        tier="PRO"
        on={packs.ndaReviewersGuide}
        onToggle={() => onTogglePack('ndaReviewersGuide')}
      />
      */}
      <p className="text-[12px] text-slate-400 mt-3">
        More packs coming soon — EMA, TGA, ICH.
      </p>
    </div>
  )
}
